const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottomRight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      fill: "white",
      fillOpacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41721 2.91715C3.26099 3.07336 3.26099 3.32662 3.41721 3.48283L8.73437 8.8H5.30005C5.07914 8.8 4.90005 8.97912 4.90005 9.2C4.90005 9.42088 5.07914 9.6 5.30005 9.6H9.70005C9.80613 9.6 9.90789 9.55784 9.98293 9.48288C10.0579 9.40784 10.1001 9.30608 10.1001 9.2V4.79999C10.1001 4.57908 9.92093 4.39999 9.70005 4.39999C9.47917 4.39999 9.30005 4.57908 9.30005 4.79999V8.23432L3.98289 2.91714C3.82668 2.76093 3.57342 2.76093 3.41721 2.91715Z",
    fill: "#000713",
    fillOpacity: 0.624,
    style: {
      fill: "#000713",
      fill: "color(display-p3 0.0008 0.0256 0.0752)",
      fillOpacity: 0.624
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomRight);
export default __webpack_public_path__ + "static/media/arrow-bottom-right.d4ba7e9af0089fc449e5e4bd1728b52b.svg";
export { ForwardRef as ReactComponent };